module.exports = __webpack_public_path__ + "static/hot-pockets-13720f8663c367851a9ccd486631410c.svg";